import { Component } from '@angular/core';
import {
    UilabMatIconButton,
    UilabMatIconModule,
    UilabMatTreeModule,
} from '@uilab/ng-mat-components';
import { ICONS } from 'src/app/shared/constants/icons';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface TreeNode {
    readonly name: string;
    readonly children?: TreeNode[];
}

interface TreeExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly nodes: TreeNode[];
}

@Component({
    selector: 'avd-tree-examples',
    templateUrl: './tree-examples.component.html',
    styleUrls: ['./tree-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatTreeModule,
        UilabMatIconButton,
        UilabMatIconModule,
    ],
})
export class TreeExamplesComponent {
    readonly ICONS = ICONS;
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/story/components-tree--default`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/tree`;
    readonly childrenAccessor = (node: TreeNode): TreeNode[] =>
        node.children ?? [];
    readonly hasChild = (_index: number, node: TreeNode): boolean =>
        !!node.children?.length;

    readonly examples: readonly TreeExample[] = [
        {
            variant: 'basic',
            label: 'Basic Tree',
            description:
                'Use a basic tree to present hierarchical-looking item lists with keyboard-friendly tree semantics.',
            htmlSnippet: `<uilab-mat-tree [dataSource]="nodes" [childrenAccessor]="childrenAccessor" #tree="uilabMatTree">
    <uilab-mat-tree-node *uilabMatTreeNodeDef="let node; when: hasChild" uilabMatTreeNodePadding>
        <button uilabMatIconButton uilabMatTreeNodeToggle aria-label="Toggle node">
            <uilab-mat-icon [svgIcon]="tree.isExpanded(node) ? ICONS.expandFilled : ICONS.nextFilled"></uilab-mat-icon>
        </button>
        {{ node.name }}
    </uilab-mat-tree-node>
    <uilab-mat-tree-node *uilabMatTreeNodeDef="let node" uilabMatTreeNodePadding>
    <button uilabMatIconButton disabled></button>
    {{ node.name }}
  </uilab-mat-tree-node>
</uilab-mat-tree>`,
            nodes: [
                {
                    name: 'Asset Library',
                    children: [
                        { name: 'Pumps' },
                        { name: 'Compressors' },
                        { name: 'Heat Exchangers' },
                    ],
                },
                {
                    name: 'Operations',
                    children: [{ name: 'Area A' }, { name: 'Area B' }],
                },
            ],
        },
    ];
}
